import { CommandBase } from "../../../../common/services/cqs/commandManager";

export class SetLeverantorsorderradKvantitetCommand extends CommandBase {
    leverantorsorderradId: number;
    overenskommenKvantitetLeveransrad: number;

    constructor(init: (instance: SetLeverantorsorderradKvantitetCommand) => void) {
        super("SetLeverantorsorderradKvantitetCommand");
        init(this);
    }
}
